import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import TextGeneratorLayer from "../components/TextGeneratorLayer";

const FinaxChatPage = () => {
  return (
    <div>
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Home" />

        {/* DashBoardLayerOne */}
        <TextGeneratorLayer />
      </MasterLayout>
    </div>
  );
};

export default FinaxChatPage;
